import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { AxiosResultDefaultError } from '../../../api/request';
import { getPeriod, Period } from '../../../api/requests/periods';
import { AuthenticationError } from '../../../api/requests/tuitionProcess';
import { createFetchContext } from '../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../components/info/DisplayError';
import Loading from '../../../components/info/Loading';

export interface PeriodRecord extends Period {
  academicYear: number;
}

export interface PeriodRecordLoaderProps {
  periodId: number | string;
  children: (period: PeriodRecord) => JSX.Element;
}

const { FetchProvider, FetchConsumer } = createFetchContext<
  undefined,
  Period,
  AuthenticationError | AxiosResultDefaultError
>();

export const PeriodRecordLoaderConsumer = FetchConsumer;

export default function PeriodRecordLoader({
  periodId,
  children,
}: PeriodRecordLoaderProps) {
  const { id } = useParams<{ id: string }>();
  const periodIdFromUrl = id ? Number(id) : periodId;

  const request = useCallback(async () => {
    return getPeriod(periodIdFromUrl);
  }, [periodIdFromUrl]);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return <Loading insideCard />;
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children(data);
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
